import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { UseContexts } from './components/UseContexts';
import { PainPoints } from './components/PainPoints';
import { TomosSection } from './components/TomosSection';
import { Button } from './components/Button';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-[#ff2e92]/30 selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBar data-id="element-3" />
      <UseContexts data-id="element-4" />
      <PainPoints data-id="element-5" />
      <TomosSection data-id="element-6" />

      <div className="py-8 md:py-12 text-center px-4" data-id="element-7">
        <Button href="#comprar" className="text-base md:text-2xl py-4 md:py-5 px-6 md:px-10" data-id="element-8">
          👉 Acceder al Mega Kit Scooter ahora
        </Button>
      </div>

      <Bonuses data-id="element-9" />

      <div className="py-8 md:py-12 text-center bg-zinc-900/30 px-4" data-id="element-10">
        <Button href="#comprar" className="text-base md:text-2xl py-4 md:py-5 px-6 md:px-10" data-id="element-11">
          👉 Acceder al Mega Kit Scooter ahora
        </Button>
      </div>

      <Testimonials data-id="element-12" />
      <UrgencySection data-id="element-13" />
      <PricingSection data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <PurchasePopup data-id="element-17" />
    </div>;
}